const config = {
  // SERVER_URL: "http://3.29.243.136:5000/",
  // SERVER_URL: "http://40.172.150.75:5000/",
  // SERVER_URL: "http://localhost:5000",
  SERVER_URL: "https://api.prod.backend.onenessmgt.com",
  VERSION: "/api/admin/v1",
};
export default config;
